import { NocoHttpClient } from '@noco/http-client';
import { createConfigurationWithToken } from '../utils';
var Configuration = NocoHttpClient.Configuration;
var ContactSettingApi = /** @class */ (function () {
    function ContactSettingApi(basePath, fetchApi) {
        this.basePath = basePath;
        this.fetchApi = fetchApi;
    }
    ContactSettingApi.initialize = function (basePath, fetchApi) {
        if (!ContactSettingApi.instance) {
            ContactSettingApi.instance = new ContactSettingApi(basePath, fetchApi);
        }
        return ContactSettingApi.instance;
    };
    ContactSettingApi.prototype.ApiFactory = function (idToken) {
        var config = createConfigurationWithToken({
            basePath: this.basePath,
            fetchApi: this.fetchApi,
            idToken: idToken,
            type: 'user'
        });
        return new NocoHttpClient.ApiUserV1ContactSettingApi(new Configuration(config));
    };
    return ContactSettingApi;
}());
export { ContactSettingApi };
